<template>
  <div>
    <div v-if="!productMark.media_src">
      <file-pond
          name="image"
          ref="pond"
          label-idle="Hier klicken oder Bild reinziehen..."
          :allow-multiple="false"
          :accepted-file-types="acceptedFiles()"
          maxFileSize="1MB"
          :server="server"
          @processfile="afterUpload"
          :disabled="disabled"
      />
    </div>
    <div v-else>
      <br>
      <div class="row" style="display: flex; align-items: center">
        <div class="col-md-1">
          <button class="btn btn-danger float-right" style="margin-top: 50%;" slot="browse-btn"
                  content="Bild entfernen"
                  @click="removeImage()"
                  :disabled="disabled"
                  v-tippy><i class="fa fa-trash"></i>
          </button>
        </div>
        <div class="col-md-11">
          <div style="display: flex; justify-content: center;  background: #eeeeee; border-radius: 15px ">
            <video controls :src="productMark.media_src"
                   v-if="productMark.media_src.includes('.mov') || productMark.media_src.includes('.mp4')"></video>
            <img v-else :src="productMark.media_src" style="max-width: 100%; max-height: 300px">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import vueFilePond, {setOptions} from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import de_DE from "filepond/locale/de-de"

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

setOptions(de_DE)

export default {
  name: 'ContentPreviewProductMark',
  components: {FilePond},
  props: ['index', 'disabled', 'productMark'],
  data() {
    return {
      files: [],
      server: {
        url: '/api/content-hub/image/upload',
        process: {
          url: '',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 7000,
          ondata: (formData) => {
            formData.append('id', this.record.id);
            formData.append('client_id', this.record.client_id)
            return formData;
          },
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      'channels': 'getChannels',
      'mediaType': 'getMediaType',
      user: 'getUser',
      record: 'getRecord'
    })
  },
  methods: {
    acceptedFiles() {
      return 'image/jpeg, image/png, video/mov, video/mp4, video/quicktime, video/webm';
    },
    isVideo(url) {
      return (url.includes('.mov') || url.includes('.mp4'))
    },
    removeImage() {
      this.productMark.media_src = null;
    },
    afterUpload(error, file) {
      const response = JSON.parse(file.serverId);

      this.productMark.media_src = response.content_url;

      this.$parent.$forceUpdate();

      this.$emit('update:channels', this.channels)
    },
    triggerFileUploader() {
      document.getElementById("file").click()
    }
  }
}
</script>

<style scoped>
</style>
